import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../bootstrap/Button';
import { CardFooter, CardFooterLeft, CardFooterRight } from '../bootstrap/Card';
import Spinner from '../bootstrap/Spinner';
import {
	navigateBackwardToPage,
	navigateForwardToPage,
	// navigateToNextSection,
} from '../../utils/genericFuncs';

const StandardFooter = ({
	hasBackButton,
	hasContinueButton,
	hasDisabledContinueButton,
	hasNextSectionButton,
	hasRelocCompleteButton,
	backButtonText,
	continueButtonText,
	nextSectionButtonText,
	relocCompleteText,
	moveToNextSectionFunc,
	moveToNextSectionData,
	// nextSectionKey,
	// setActiveSectionKey,
	setStepNum,
	setActivePageName,
	prevPage,
	stepNum,
	nextPage,
	disclaimerText,
	onClickFunction,
	onClickFunctionData,
	onClickBackButtonFunction,
	onClickBackButtonFunctionData,
	mobileSpacing,
	loadingButtonText,
	isLoading,
	// Used to stack components above buttons
	additionalComponents,
}) => {
	const [isSubmitting, setIsSubmitting] = useState(false);

	return (
		<CardFooter className={additionalComponents.length > 0 ? 'flex-column' : ''}>
			{additionalComponents.length > 0 && (
				<>
					<div className='col-12'>{additionalComponents}</div>
					{!mobileSpacing && <br />}
				</>
			)}
			<div className='col-12 flex-column'>
				{disclaimerText !== null && (
					<div className='col-12 pt-2 pb-0 mb-0'>
						<p className='text-muted table-section-subtitle mb-0'>{disclaimerText}</p>
						<br />
					</div>
				)}
				<div
					className={
						additionalComponents.length > 0 ? 'col-12 d-flex' : 'col-12 d-flex flex-row'
					}>
					{hasBackButton === true && (
						<CardFooterLeft>
							<Button
								color='info'
								isOutline
								// size='lg'
								onClick={async () => {
									let shouldNavigate = true;
									if (onClickBackButtonFunction !== null) {
										setIsSubmitting(true);
										// note: no error handling here
										try {
											const result = await onClickBackButtonFunction(
												onClickBackButtonFunctionData,
											);
											if (result === false) {
												shouldNavigate = false;
											}
										} catch (error) {
											shouldNavigate = false;
										} finally {
											setIsSubmitting(false);
										}
									}
									if (shouldNavigate) {
										navigateBackwardToPage(
											stepNum,
											prevPage,
											setStepNum,
											setActivePageName,
										);
									}
								}}
								disabled={isLoading || isSubmitting}>
								{(isLoading || isSubmitting) && (
									<>
										{loadingButtonText && <>{loadingButtonText}&nbsp;&nbsp;</>}
										<Spinner isSmall inButton color='dark' />
									</>
								)}
								{!isLoading && !isSubmitting && backButtonText}
							</Button>
						</CardFooterLeft>
					)}
					<CardFooterRight>
						{hasContinueButton === true && (
							<Button
								color='info'
								// size='lg'
								onClick={async () => {
									let shouldNavigate = true;
									if (onClickFunction !== null) {
										setIsSubmitting(true);
										// note: no error handling here
										try {
											const result = await onClickFunction(
												onClickFunctionData,
											);
											if (result === false) {
												shouldNavigate = false;
											}
										} catch (error) {
											shouldNavigate = false;
										} finally {
											setIsSubmitting(false);
										}
									}
									if (shouldNavigate) {
										navigateForwardToPage(
											stepNum,
											nextPage,
											setStepNum,
											setActivePageName,
										);
									}
								}}
								disabled={isLoading || isSubmitting}>
								{(isLoading || isSubmitting) && (
									<>
										{loadingButtonText && <>{loadingButtonText}&nbsp;&nbsp;</>}
										<Spinner isSmall inButton color='light' />
									</>
								)}
								{!isLoading && !isSubmitting && continueButtonText}
							</Button>
						)}
						{hasDisabledContinueButton === true && (
							<Button
								color='info'
								// size='lg'
								disabled
								onClick={() => {
									return null;
								}}>
								{continueButtonText || 'Continue'}
							</Button>
						)}
						{hasNextSectionButton === true && (
							<Button
								color='info'
								// size='lg'
								onClick={() => {
									moveToNextSectionFunc(moveToNextSectionData);
									// navigateToNextSection(
									// 	nextSectionKey,
									// 	setActiveSectionKey,
									// 	setActivePageName,
									// 	setStepNum,
									// 	nextPage,
									// );
								}}>
								{nextSectionButtonText}
							</Button>
						)}
						{hasRelocCompleteButton === true && (
							<Button
								color='info'
								// size='lg'
								onClick={async () => {
									if (onClickFunction !== null) {
										setIsSubmitting(true);
										// note: no error handling here
										await onClickFunction(onClickFunctionData);
										setIsSubmitting(false);
									}
								}}
								disabled={isSubmitting}>
								{isSubmitting && <Spinner isSmall color='dark' />}
								{isSubmitting ? '' : relocCompleteText}
							</Button>
						)}
					</CardFooterRight>
				</div>
			</div>
		</CardFooter>
	);
};

StandardFooter.propTypes = {
	hasBackButton: PropTypes.bool,
	hasContinueButton: PropTypes.bool,
	hasDisabledContinueButton: PropTypes.bool,
	hasNextSectionButton: PropTypes.bool,
	hasRelocCompleteButton: PropTypes.bool,
	setStepNum: PropTypes.func.isRequired,
	stepNum: PropTypes.number.isRequired,
	setActivePageName: PropTypes.func.isRequired,
	backButtonText: PropTypes.string,
	prevPage: PropTypes.string,
	continueButtonText: PropTypes.string,
	relocCompleteText: PropTypes.string,
	nextSectionButtonText: PropTypes.string,
	nextPage: PropTypes.string,
	disclaimerText: PropTypes.string,
	// nextSectionKey: PropTypes.string,
	// setActiveSectionKey: PropTypes.func,
	moveToNextSectionFunc: PropTypes.func,
	// eslint-disable-next-line react/forbid-prop-types
	moveToNextSectionData: PropTypes.object,
	onClickFunction: PropTypes.func,
	// eslint-disable-next-line react/forbid-prop-types
	onClickFunctionData: PropTypes.object,
	onClickBackButtonFunction: PropTypes.func,
	// eslint-disable-next-line react/forbid-prop-types
	onClickBackButtonFunctionData: PropTypes.object,
	mobileSpacing: PropTypes.bool,
	// eslint-disable-next-line react/forbid-prop-types
	additionalComponents: PropTypes.array,
	loadingButtonText: PropTypes.string,
	isLoading: PropTypes.bool,
};
StandardFooter.defaultProps = {
	backButtonText: 'Back',
	continueButtonText: 'Continue',
	nextSectionButtonText: 'Next Section',
	relocCompleteText: 'Complete',
	hasBackButton: false,
	hasContinueButton: false,
	hasDisabledContinueButton: false,
	nextPage: '',
	prevPage: ',',
	hasNextSectionButton: false,
	// nextSectionKey: '',
	hasRelocCompleteButton: false,
	// setActiveSectionKey: () => {},
	moveToNextSectionFunc: () => {},
	moveToNextSectionData: {},
	onClickFunction: null,
	onClickFunctionData: null,
	onClickBackButtonFunction: null,
	onClickBackButtonFunctionData: null,
	mobileSpacing: false,
	loadingButtonText: null,
	disclaimerText: null,
	additionalComponents: [],
	isLoading: false,
};

export default StandardFooter;
